import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Stack,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAltOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import { formatNumber } from "../../utils/constant";
import { Skeleton } from "@mui/material";

const StyledCard = styled(Card)(() => ({
  borderRadius: '16px',
  boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
  border: '1px solid #f1f5f9',
  transition: 'all 0.2s ease-in-out',
  height: '100%',
  '&:hover': {
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transform: 'translateY(-2px)',
  },
}));

const MetricCard = ({ title, value, change, changeType, icon, color, subtitle }) => {

  return (
  <StyledCard>
      <CardContent sx={{ p: 1.5, height: '100px', display: 'flex', flexDirection: 'column' }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box sx={{flexDirection: 'column-reverse',display: 'flex'}}>
          <Typography 
              variant="h4" 
              sx={{ 
                fontWeight: 700,
                color: '#1e293b',
                mb: 0.5,
                fontSize: '26px',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
        {value}
      </Typography>
            <Typography 
              variant="body2" 
              sx={{ 
                fontWeight: 700,
                fontSize: "2rem",
                color: "#424242",
                mb: 1
              }}
            >
        {title}
      </Typography>
          </Box>
          <Box sx={{ color }}>
            {icon}
          </Box>
        </Stack>
    </CardContent>
  </StyledCard>
);
};

const MetricCardSkeleton = () => {
  return (
    <StyledCard>
      <CardContent
        sx={{
          p: 3,
          height: "100px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Stack spacing={1}>
          {/* Value */}
          <Skeleton width={90} height={34} />

          {/* Title */}
          <Skeleton width={120} height={18} />
        </Stack>
      </CardContent>
    </StyledCard>
  );
};

export const CustomerAnalyticsDashboardCards = ({
  loading = false,
  successRateChange = 0,
  totalCustomers = 0,
  activeCustomers = 0,
  totalApiCalls = 0,
  totalCreditConsumed = 0,
  totalRequestsChangePercentage = 0,
  usagePercentage = 0
}) => {
  return (
    <Box>
      <Grid container spacing={3} sx={{
        mb: 4,
        // '& > .MuiGrid-item': {
        //   '@media (max-width: 1211px)': {
        //     flexBasis: '50%',
        //     maxWidth: '50%',
        //   },
        // },
      }}>
        {loading ? (
          [1, 2, 3, 4].map((_, index) => (
            <Grid item xs={12} sm={6} lg={3} key={index}>
              <MetricCardSkeleton />
            </Grid>
          ))
        ) : (
        <>
        <Grid item xs={12} sm={6} lg={3}>
          <MetricCard
            title="Total Customers"
            value={totalCustomers}
            change={`${totalRequestsChangePercentage > 0 ? "+" : ""}${totalRequestsChangePercentage}%`}
            icon={<PeopleAltOutlinedIcon sx={{ fontSize: "2.25rem" }} />}
            color="#6366f1"
            subtitle="This month"
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <MetricCard
            title="Active Customers"
            value={activeCustomers}
            change={`${successRateChange > 0 ? "+" : ""}${successRateChange}%`}
            changeType={successRateChange >= 0 ? "positive" : "negative"}
            icon={<PersonOutlineOutlinedIcon sx={{ fontSize: "2.25rem" }} />}
            color="#10b981"
            subtitle="Average uptime"
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <MetricCard
            title="Total API Calls"
            value={formatNumber(totalApiCalls)}
            icon={<TimelineOutlinedIcon sx={{ fontSize: "2.25rem" }} />}
            color="#f59e0b"
            subtitle="Currently running"
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <MetricCard
            title="Credits Consumed"
            value={formatNumber(totalCreditConsumed)}
            change={`${usagePercentage > 0 ? "+" : ""}${usagePercentage}%`}
            changeType={usagePercentage >= 0 ? "positive" : "negative"}
            icon={<CreditCardOutlinedIcon sx={{ fontSize: "2.25rem" }} />}
            color="#8b5cf6"
            subtitle="Credits remaining"
          />
        </Grid>
        </>
        )}
      </Grid>
    </Box>
  );
};